import { createReducer } from '@reduxjs/toolkit'
import { doLogin } from '../actions/authentication'
import { APIData, APIStatus } from '../axiosConfiguration'
import { LoginResponseHandler } from '../type/authentication'
import { AuthorizationHandler } from '../authorizationHandler'

export const initialState: APIData<LoginResponseHandler> = {
  status: APIStatus.IDLE
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(doLogin.fulfilled, (state, action) => {
      state.status = APIStatus.FULFILLED

      AuthorizationHandler.initSession(action.payload)
    })
    .addCase(doLogin.rejected, (state, action) => {
      state.error = action.payload
      state.status = APIStatus.REJECTED

      AuthorizationHandler.clearSession()
    })
    .addCase(doLogin.pending, (state) => {
      state.status = APIStatus.PENDING
    })
})
